module.exports = {
  COMPANY: 'https://undefinedlabs.com',
  TWITTER: 'https://twitter.com/undefinedlabs',
  LINKEDIN: 'https://www.linkedin.com/company/undefinedlabs/about',
  EMAIL: 'contact@undefinedlabs.com',
  EMAIL_PRIVACY: 'info@undefinedlabs.com',
}
